import ServiceCRUD from '../../../../services/ServiceGasOrder';

class OportunnityNumberService extends ServiceCRUD {
  constructor() {
    super(`/api/numero-oportunidade`);
  }
}

export default new OportunnityNumberService();
